import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Box } from "@mui/material";
import {
  DataGrid,
  GridActionsCellItem,
  GridToolbar,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { useCallback, useEffect, useMemo, useState } from "react";

import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import { API } from "../../../api/API";
import { appColors } from "../../../constant/constant";
import useAuthStore from "../../../store/authStore";
import DeleteDialog from "../modals/DeleteModal";
import ModifiPolice from "../modals/ModifiPolice";
import RegisterPolice from "../modals/RegisterPolice";
import VuePolice from "../modals/vuePolice";

// Composant pour la barre d'outils avec un bouton "Ajouter un stagiaire"

// Toolbar component with additional button

const actionTypes = {
  voir: "voir",
  modifier: "modifier",
  delete: "delete",
};
const iconList = [
  <VisibilityOutlinedIcon sx={{ color: appColors.secondary }} />,
  <TipsAndUpdatesIcon sx={{ color: appColors.secondary }} />,
  /* <BookIcon sx={{ color: appColors.warning }} />,*/

  <DeleteOutlineOutlinedIcon sx={{ color: appColors.danger }} />,
];
const DataGridPolice = () => {
  const [isLoading, setisLoading] = useState(true);

  const [selectedRow, setselectedRow] = useState(null);
  const [pagination, setpagination] = useState({ page: 1, limit: 50 });
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  //updatestagiaire state
  const user = useAuthStore((state) => state.user);
  const [isVisibleVoir, setIsVisibleVoir] = useState(false);
  const [isVisibleModifier, setIsVisibleModifier] = useState(false);
  const [isVisibleDelete, setIsVisibleDelete] = useState(false);

  const handleAction = useCallback((row, actionType) => {
    //row is the row data
    //actionType is the action type : seedetail,  addRapport, addJT
    setselectedRow(row);
    switch (actionType) {
      case actionTypes.voir:
        setIsVisibleVoir(true);
        break;

      case actionTypes.delete:
        // Delete logic here
        setIsVisibleDelete(true); // Open delete <dialog></dialog>

        break;
      case actionTypes.modifier:
        setIsVisibleModifier(true);
        break;

      default:
        break;
    }
  }, []);

  /**handleDelete item */

  const handleDeleteConfirm = async () => {
    if (!selectedRow) return;
    try {
      const res = await API.delete(`/polices/${selectedRow.id}`);
      if (res.status === 200 || res.status === 204) {
        handleRefresh();
        setIsDeleteDialogOpen(false);
      }
    } catch (error) {
      console.log(error.message);
      setIsDeleteDialogOpen(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        field: "order",
        headerName: "#",
        width: 80,
      },
      {
        field: "numero",
        width: 160,
      },
      {
        field: "label",
      },
      {
        field: "description",
        width: 200,
      },

      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 80,
        disableExport: true,
        getActions: (params) =>
          Object.entries(actionTypes).map((i, index) => {
            return (
              <GridActionsCellItem
                icon={iconList[index]}
                label={`${i[1]}`}
                key={i[0]}
                onClick={() => handleAction(params.row, i[1])}
                showInMenu
              />
            );
          }),
      },
    ],
    [handleAction]
  );

  const [rows, setRows] = useState([]);
  useEffect(() => {
    //fetch data from api
    getPolices();
  }, []);
  // Fonction de rafraîchissement des données
  const handleRefresh = () => {
    setisLoading(true);
    getPolices();
  };

  //get stagiaire function from api
  const getPolices = () => {
    const { pays } = user;
    API.get(`/polices`)
      .then((response) => {
        const data = response.data.data.map((row, index) => ({
          ...row,
          order: index + 1, // Ajouter le numéro d'ordre
        }));
        setRows(data);
        setisLoading(false);
      })
      .catch((error) => {
        console.log(error.message);
        setisLoading(false);
      });
  };

  const CustomToolbar = () => (
    <GridToolbarContainer sx={{ backgroundColor: "#f5f5f5", color: "#37B049" }}>
      <GridToolbar
        sx={{
          "& .MuiButton-root": {
            color: "#37B049",
          },
          "& .MuiSvgIcon-root": {
            color: "#37B049",
          },
        }}
      />
      <RegisterPolice onRefresh={handleRefresh} />
    </GridToolbarContainer>
  );

  return (
    <Box sx={{ width: "100%" }}>
      <DataGrid
        slots={{
          toolbar: () => <CustomToolbar />,
        }}
        columns={columns}
        rows={rows}
        checkboxSelection
        disableRowSelectionOnClick
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: pagination.limit,
            },
          },
        }}
        pageSizeOptions={[pagination.limit]}
        loading={isLoading}
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "linear-progress",
          },
        }}
      />

      {isVisibleVoir && selectedRow && (
        <VuePolice
          show={isVisibleVoir}
          handleClose={() => setIsVisibleVoir(false)}
          police={selectedRow}
        />
      )}

      {isVisibleDelete && selectedRow && (
        <DeleteDialog
          isDeleteDialogOpen={isVisibleDelete}
          setIsDeleteDialogOpen={setIsVisibleDelete}
          handleDeleteConfirm={handleDeleteConfirm}
          message={`Voulez vous supprimer la police: ${selectedRow.label} ?`}
        />
      )}
      {isVisibleModifier && selectedRow && (
        <ModifiPolice
          show={isVisibleModifier}
          handleClose={() => setIsVisibleModifier(false)}
          onRefresh={handleRefresh}
          police={selectedRow}
        />
      )}
    </Box>
  );
};

export default DataGridPolice;
